<template>
	<v-main class="w-auto">
		<Navbar />
		<router-view></router-view>
	</v-main>
</template>

<script>
import { mapState } from "vuex";
import { useTheme } from "vuetify";

import Navbar from "@/components/TheNavbar";
import {
	LOAD_HOSTS,
	LOAD_PROFILES,
	LOAD_KEYS,
	LOAD_LOGS,
	LOAD_TERMINAL,
	LOAD_RC,
	LOAD_TRANSACTIONS,
	LOAD_RULESBYAMOUNT,
	LOAD_PROTOCOL,
} from "@/store/_actiontypes";
export default {
	components: {
		Navbar,
	},
	mounted() {
		this.$store.dispatch(`hosts/${LOAD_HOSTS}`);
		this.$store.dispatch(`keys/${LOAD_KEYS}`);
		this.$store.dispatch(`logs/${LOAD_LOGS}`);
		this.$store.dispatch(`responscodes/${LOAD_RC}`);
		this.$store.dispatch(`rulesbyamount/${LOAD_RULESBYAMOUNT}`);
		this.$store.dispatch(`terminals/${LOAD_TERMINAL}`);
		this.$store.dispatch(`transactions/${LOAD_TRANSACTIONS}`);
		this.$store.dispatch(`account/${LOAD_PROFILES}`);
		this.$store.dispatch(`protocols/${LOAD_PROTOCOL}`);

		if (localStorage.getItem("theme") == "dark") {
			this.$store.state.account.user.useDarkMode = 1;
		} else {
			this.$store.state.account.user.useDarkMode = 0;
		}

        this.$vuetify.theme.change( this.$store.state.account.user.useDarkMode ? "dark" : "light")
	},
	computed: {
		...mapState({
			theme: (state) =>
				state.account.user ? state.account.user.useDarkMode : false,
		}),
	},
	watch: {
		theme(newTheme, oldTheme) {
			localStorage.setItem(
				"theme",
                (this.$vuetify.theme.change(newTheme ? "dark" : "light"))
			);
		},
	},
	data: () => ({
		//
	}),
};
</script>
<style>
/* scroll bar style */
::-webkit-scrollbar-track {
	--webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
	background-color: #f5f5f5;
}

::-webkit-scrollbar {
	width: 10px;
	height: 8px;
}

::-webkit-scrollbar-thumb {
	background-color: #757575;
}

.form-label label[for] {
	height: 20px;
	font-size: 10pt;
}

.tableHeader {
	height: 20px;
	font-size: 16px !important;
}

.singleAppbar {
	margin-top: 48px;
}

.doubleAppbar {
	margin-top: 92px;
}

.v-select__slot {
	font-size: smaller;
}

.v-text-field__slot {
	font-size: smaller;
}
</style>
